import React, { useState, useEffect } from "react";
import { GoogleMap, Marker, InfoWindow } from "@react-google-maps/api";
import { useSelector, useDispatch } from "react-redux";
import { api } from "common";
import { useTranslation } from "react-i18next";
import CircularLoading from "../components/CircularLoading";

const containerStyle = {
  width: "100%",
  height: "calc(100vh - 120px)",
  borderRadius: "12px",
};

const defaultCenter = { lat: 14.5995, lng: 120.9842 };

export default function DriverMap() {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { fetchDrivers } = api;
  const drivers = useSelector((state) => state.usersdata.drivers);
  const [selectedDriver, setSelectedDriver] = useState(null);
  const [mapCenter, setMapCenter] = useState(defaultCenter);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    dispatch(fetchDrivers("web"));
    const interval = setInterval(() => {
      dispatch(fetchDrivers("web"));
    }, 10000);
    return () => clearInterval(interval);
  }, [dispatch, fetchDrivers]);

  useEffect(() => {
    if (drivers && drivers.length > 0) {
      const withLocation = drivers.filter(
        (d) => d.location && d.location.lat && d.location.lng
      );
      if (withLocation.length > 0) {
        setMapCenter({
          lat: withLocation[0].location.lat,
          lng: withLocation[0].location.lng,
        });
      }
      setLoaded(true);
    } else if (drivers) {
      setLoaded(true);
    }
  }, [drivers]);

  // fetchDrivers already filters to approved + driverActiveStatus == true
  // just need to ensure location data exists
  const activeDrivers = drivers
    ? drivers.filter((d) => d.location && d.location.lat && d.location.lng)
    : [];

  if (!loaded) return <CircularLoading />;

  return (
    <div>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: 16,
        }}
      >
        <h2 style={{ margin: 0, fontSize: 20, fontWeight: 700 }}>
          {t("realtime_drivers")}
        </h2>
        <div
          style={{
            background: "#e8f9fc",
            padding: "6px 14px",
            borderRadius: 20,
            fontSize: 13,
            fontWeight: 600,
            color: "#009689",
          }}
        >
          {activeDrivers.length} {t("active_driver")}
        </div>
      </div>

      <GoogleMap
        mapContainerStyle={containerStyle}
        center={mapCenter}
        zoom={12}
        options={{
          zoomControl: true,
          streetViewControl: false,
          mapTypeControl: false,
          fullscreenControl: true,
        }}
      >
        {activeDrivers.map((driver) => (
          <Marker
            key={driver.id}
            position={{ lat: driver.location.lat, lng: driver.location.lng }}
            onClick={() => setSelectedDriver(driver)}
          />
        ))}

        {selectedDriver && selectedDriver.location && (
          <InfoWindow
            position={{
              lat: selectedDriver.location.lat,
              lng: selectedDriver.location.lng,
            }}
            onCloseClick={() => setSelectedDriver(null)}
          >
            <div style={{ padding: 4, minWidth: 160 }}>
              <p style={{ margin: 0, fontWeight: 700, fontSize: 14 }}>
                {selectedDriver.firstName} {selectedDriver.lastName}
              </p>
              <div
                style={{
                  marginTop: 6,
                  fontSize: 12,
                  display: "flex",
                  flexDirection: "column",
                  gap: 3,
                }}
              >
                {selectedDriver.carType && (
                  <span>
                    <strong>{t("car_type")}:</strong> {selectedDriver.carType}
                  </span>
                )}
                {selectedDriver.vehicleNumber && (
                  <span>
                    <strong>{t("vehicle_no")}:</strong>{" "}
                    {selectedDriver.vehicleNumber}
                  </span>
                )}
                <span
                  style={{
                    marginTop: 4,
                    color: selectedDriver.queue ? "#f59e0b" : "#0cab03",
                    fontWeight: 600,
                  }}
                >
                  {selectedDriver.queue ? t("queue") : t("on_duty")}
                </span>
              </div>
            </div>
          </InfoWindow>
        )}
      </GoogleMap>
    </div>
  );
}
